<template>
  <div class="number-block" v-html="number"></div>
</template>

<script>
export default {
  name: "NumberBlock",
  props: {
    number: Number
  }
}
</script>

<style lang="scss">
  .number-block {
    align-items: center;
    background: transparent;
    border: 2px solid $secondary_green;
    color: $white;
    display: flex;
    font-family:"basic-sans";
    font-size: 30px;
    font-weight: bold;
    height: 40px;
    justify-content: center;
    margin: 0 auto 20px auto;
    padding: 0;
    text-align: center;
    width: 40px;
  }
</style>